// removed by extract-text-webpack-plugin
module.exports = {"changePassword":"cHzMwGJ4Y74nLAInHSB-O","title":"_3w5kvpzISyVmMiJO6Tr2Cg","authorization_buttons":"_1NdaKzmPoF0jFCCX8ntT1G","spinner":"_3EngauD3tUwYXsU1DZmsma"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserAuthentication/ChangePassword/ChangePassword.scss
// module id = 1785
// module chunks = 0